import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#000";
function SYS({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" strokeMiterlimit={10} fill={color}><path d="M13.597 7.745c-2.306.092-2.738 1.955-.217 3.216 3.674 1.838 4.033 4.9 1.726 6.674q-.116.09-.243.176l-.012.007c-.134.086-.264.179-.407.255-.07.039-.15.072-.223.108l-.041.02c-.065.03-.124.072-.19.1q-.105.047-.212.092c-.012.002-.02.01-.032.012a8 8 0 01-1.521.436c-1.965.371-4.564.217-7.709-.783a11.38 11.38 0 008.376 2.307q.315-.035.623-.092a11.5 11.5 0 002.352-.671h.003q.6-.246 1.15-.55a9.3 9.3 0 001.604-1.111c2.72-2.365 2.979-5.72.578-7.988-.8-.757-1.91-1.381-3.303-1.82-.142-.045-.272-.097-.42-.138-.718-.196-1.35-.271-1.882-.25" /><path d="M12.153 3.556a11.7 11.7 0 00-4.02.843H8.13a9.9 9.9 0 00-2.754 1.66C1.66 9.293 2.537 14.374 8.52 16.008q.534.146 1.001.205c3.047.394 3.912-1.764 1.098-3.173a7.6 7.6 0 01-1.779-1.201q-.003-.002-.002 0c-2.325-2.149-1.673-4.984 1.384-6.23l.031-.013c2.056-.828 5.19-.937 9.23.347a11.3 11.3 0 00-7.33-2.386" /></Svg>;
}
SYS.DefaultColor = DefaultColor;
export default SYS;